import {Component, inject, OnInit, Signal} from '@angular/core';
import {ApplicationCommonComponent} from '../application.common.component';
import {ApplicationAppEntityApplicationRead} from '../../../../../openapi';
import {BaseInfoForm} from './forms/base-info.form';
import {StagesComponent} from '../../../../../common/stages/stages.component';
import {SpinnerComponent} from '../../../../../common/spinner/spinner.component';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ValidationErrorsComponent} from '../../../../../common/validation-errors/validation-errors.component';
import {AlertComponent} from '../../../../../common/alert/alert.component';
import {DatePickerComponent} from '../../../../../common/date-picker/date-picker.component';
import {UISettings} from "../../../../../services/ssession.service";
import {selectUISettings} from "../../../../../store/selectors/app.selectors";

export interface BaseInfoComponentConfig {
  stages: string[];
  successUrl: string;
  submissionPurposeOptions?: string[];
  entityKindOptions?: string[];
}

@Component({
  selector: 'app-base-info-section',
  standalone: true,
  providers: [BaseInfoForm],
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    AlertComponent,
    DatePickerComponent
  ],
  templateUrl: './base-info-section.component.html'
})
export class BaseInfoSectionComponent extends ApplicationCommonComponent implements OnInit {

  public stages: string[] = this.route.snapshot.data['stages'];
  public successUrl: string = this.route.snapshot.data['successUrl'];

  public submissionPurposeOptions: string[] = this.route.snapshot.data['submissionPurposeOptions'] || [
    'Złożenie informacji',
    'Korekta informacji'
  ];

  public entityKindOptions: string[] = this.route.snapshot.data['entityKindOptions'] || [
    'Właściciel, użytkownik wieczysty lub posiadacz',
    'Współwłaściciel, współużytkownik wieczysty lub współposiadacz'
  ];

  public form: BaseInfoForm = inject(BaseInfoForm);

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.updateApplication(this.successUrl, this.form.toWriteModel());
      } else {
        this.createApplication(this.successUrl, this.form.toWriteModel());
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app,
        submissionPurpose: app?.submissionPurpose || this.submissionPurposeOptions.at(0),
        entityKind: app?.entityKind || this.entityKindOptions.at(0)
      });
    }
  };

  public override ngOnInit(): void {
    this.form?.submissionPurpose?.setValue(this.submissionPurposeOptions.at(0));
    this.form?.entityKind?.setValue(this.entityKindOptions.at(0));
    super.ngOnInit();
  }
}
